
































import { computed, defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import useVehicle from '@/useVehicle';

import ProgressRenderer from '@/components/DeliveryNote/ProgressRenderer.vue';

const DeliveryNoteObject = defineComponent({
  components: {
    ProgressRenderer,
  },
  props: {
    vehicleType: { default: 'PICKUP' },
    deliveryNote: {
      default: () => ({
        id: -1,
        uniqueId: '',
        status: 'PENDING',
        driver: {},
        deliveries: [],
        deliveryDate: '',
        completedDate: null,
        failedDate: null,
        area: {
          id: -1,
          pickupTime: 1,
          sixWheelTime: 1,
          tenWheelTime: 1,
          trailerTime: 1,
        },
      }),
    },
  },
  setup(props) {
    const { vehicleTypeToTravelTimeKey } = useVehicle();
    function formatToCurrency(number: string | number) {
      return useFormat.number(number).currency();
    }
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const deliveryNoteInformation = computed(() => {
      let weight = 0;
      let price = 0;
      let packagesPrice = 0;
      props.deliveryNote.deliveries.forEach((delivery: any) => {
        weight += delivery.totalWeight;
        price += delivery.deliveryFee;
        delivery.packages.forEach((item: any) => {
          packagesPrice += item.price;
        });
      });

      return {
        weight,
        price,
        packagesPrice,
      };
    });

    const progressRender = computed(() => {
      const result = {
        success: 0,
        red: 0,
        gray: 0,
        blue: 0,
        yellow: 0,
      };

      const deliveryDateAsDayJS = useFormat.date(props.deliveryNote.deliveryDate).dayjs;
      let span = 1;

      const travelKey = vehicleTypeToTravelTimeKey(props.vehicleType);
      const expectDayJS = deliveryDateAsDayJS.add(props.deliveryNote.area[travelKey], 'day');
      const expectInDay = expectDayJS.diff(deliveryDateAsDayJS, 'day');
      const complete = props.deliveryNote.completedDate === null ? null : useFormat.date(useFormat.date(props.deliveryNote.completedDate).computerShortDate()).dayjs;
      const fail = props.deliveryNote.failedDate === null ? null : useFormat.date(useFormat.date(props.deliveryNote.failedDate).computerShortDate()).dayjs;
      const today = useFormat.date(useFormat.date().computerShortDate()).dayjs;
      const todayDiff = today.diff(deliveryDateAsDayJS, 'day') + 1;

      // Diff date here, the result should be positive only due to expect, complete is base value;
      // ถ้า DN เสร็จ, สำเร็จ
      if (complete !== null) {
        const successInDay = complete.diff(deliveryDateAsDayJS, 'day');
        if (complete.valueOf() > expectDayJS.valueOf() /* ช้ากว่ากำหนด */) {
          span = successInDay;
          result.success = (expectInDay / span) * 100;
          result.red = 100 - result.success;
        } else if (complete.valueOf() < expectDayJS.valueOf() /* เร็วกว่ากำหนด */) {
          span = expectInDay;
          result.success = ((successInDay || 1) / span) * 100;
          result.gray = 100 - result.success;
        } else /* เสร็จตามกำหนดการ */{
          span = successInDay;
          result.success = 100;
        }
      } else if (fail !== null) { /* DN ส่งไม่สำเร็จ, สำเร็จบางรายการ */
        const failInDay = fail.diff(deliveryDateAsDayJS, 'day');
        if (fail.valueOf() > expectDayJS.valueOf() /* ไม่สำเร็จ และช้ากว่ากำหนด */) {
          span = failInDay;
          result.yellow = (expectInDay / span) * 100;
          result.red = 100 - result.yellow;
        } else if (fail.valueOf() < expectDayJS.valueOf() /* ไม่สำเร็จ แต่เร็วกว่ากำหนด */) {
          span = expectInDay;
          result.yellow = ((failInDay || 1) / span) * 100;
          result.gray = 100 - result.yellow;
        } else /* ไม่สำเร็จ แต่ตามกำหนดการ */{
          span = failInDay;
          result.yellow = 100;
        }
      } else if (expectInDay > 0 && expectInDay > todayDiff /* ยังไม่เสร็จ และยังไม่ครบกำหนด */) {
        span = expectInDay;
        result.blue = (todayDiff / span) * 100;
        result.gray = 100 - result.blue;
      } else if (todayDiff > expectInDay /* ยังไม่เสร็จ และเลยกำหนด */) {
        span = todayDiff;
        result.blue = (expectInDay / span) * 100;
        result.red = 100 - result.blue;
      } else {
        result.blue = 100;
      }

      return {
        todayDiff,
        expectInDay,
        result,
        span,
      };
    });

    return {
      formatToCurrency,
      toCurrency,
      deliveryNoteInformation,
      progressRender,
    };
  },
});

export default DeliveryNoteObject;
